export default class QuantityTable {
    constructor(element) {
        this.elementDOM = element;
        this.mode = 'classic';
        this.table = false;
        this.productDOM = this.elementDOM.parents(
            ywdpd_qty_args.column_product_info_class
        );
        this.qtyDOM = this.productDOM.find(
            ywdpd_qty_args.product_qty_classes
        );
        this.variationForm = this.productDOM.find(
            ywdpd_qty_args.variation_form_class
        );
        this.qtyDOM.on('change', this.handleChangeQuantity.bind(this));
        this.initTable();
        this.defaultTable = this.elementDOM.html();

        if (this.variationForm) {
            this.variationForm.on(
                'show_variation',
                this.showVariationTable.bind(this)
            );
            this.variationForm.on(
                'reset_data',
                this.resetVariationTable.bind(this)
            );
        }
    }

    initTable() {
        this.table = this.elementDOM.find('#ywdpd-quantity-table');
        if (this.table.length) {
            this.table.on('click', 'td', this.handleTdClickEvent.bind(this));
        } else {
            this.table = this.elementDOM.find('#ywdpd-quantity-boxed');
            if( this.table.length) {
                this.table.on('click', '.ywdpd-boxed-item', this.handleBoxItemClickEvent.bind(this));
                this.table.on('click', '.ywdpd-boxed-item > *', this.handleBoxItemClickEvent.bind(this));
                this.mode = 'boxed';
            }
        }
        this.selectDefaultQty();
    }

    handleTdClickEvent(event) {
        event.preventDefault();
        let td = jQuery(event.target);
        this.selectRightInfo(td);
    }

    handleBoxItemClickEvent(event){
        event.preventDefault();
        event.stopImmediatePropagation();
        let item = jQuery(event.target);
        if( !item.hasClass('ywdpd-boxed-item')){
            item = item.parents('.ywdpd-boxed-item');
        }

        this.selectRightInfo(item);
    }

    selectDefaultQty() {
        if ('yes' === ywdpd_qty_args.is_default_qty_enabled) {
            if ('classic' === this.mode) {
                let td;

                if ('yes' === ywdpd_qty_args.show_minimum_price) {
                    td = this.table.find('td.qty-price-info').last();
                } else {
                    td = this.table.find('td.qty-price-info').first();
                }
                td.trigger('click');
            }else{
                let item ;
                if ('yes' === ywdpd_qty_args.show_minimum_price) {
                    item = this.table.find('.ywdpd-boxed-item').last();
                } else {
                    item = this.table.find('.ywdpd-boxed-item').first();
                }

                item.trigger('click');

            }
        }
    }

    selectRightInfo(td, updateQty = true) {
        if( this.mode === 'classic') {
            if (this.table.hasClass('vertical')) {
                let tr = td.parents('tr');
                this.toggleRow(tr, updateQty);
            } else {
                let index = td.index();
                this.toggleColumn(index, updateQty);
            }
        }else{
            this.toggleItem(td,updateQty)
        }
    }

    toggleRow(tr, updateQty) {
        this.table.find('td').removeClass('ywdpd_active');
        tr.find('td').addClass('ywdpd_active');
        let tdQty = tr.find('td.qty-info');
        if (updateQty) {
            this.updateQuantityField(tdQty);
        }

        this.updatePriceField(tdQty);
    }

    toggleItem(item,updateQty){
        this.table.find('.ywdpd-boxed-item').removeClass('ywdpd_active');
        item.addClass('ywdpd_active');
        if( updateQty ){
            this.updateQuantityField(item);
        }

        this.updatePriceField(item);
    }
    toggleColumn(columnIndex, updateQty) {
        this.table.find('td').removeClass('ywdpd_active');
        this.table
            .find('tr td:nth-of-type(' + columnIndex + ')')
            .addClass('ywdpd_active');
        let td = this.table.find(
            'tr td.qty-info:nth-of-type(' + columnIndex + ')'
        );
        if (updateQty) {
            this.updateQuantityField(td);
        }
        this.updatePriceField(td);
    }

    handleChangeQuantity(event) {
        event.stopImmediatePropagation();
        let qty = parseInt(event.target.value);
        if ('yes' === ywdpd_qty_args.is_change_qty_enabled && qty > 0) {
            const classToCheck = 'classic' === this.mode ? 'td.qty-info' : '.ywdpd-boxed-item';
            let td = this.table.find(classToCheck).filter(function () {
                let max = jQuery(this).data('qtymax');
                if (max !== '*') {
                    return (
                        jQuery(this).data('qtymin') <= qty &&
                        jQuery(this).data('qtymax') >= qty
                    );
                }
                return jQuery(this).data('qtymin') <= qty;
            });

            if (td) {
                this.selectRightInfo(td, false);
            }
        }
    }

    updateQuantityField(tdQuantity) {
        let newQty =
            '*' !== tdQuantity.data('qtymax') &&
            !ywdpd_qty_args.select_minimum_quantity
                ? tdQuantity.data('qtymax')
                : tdQuantity.data('qtymin');
        this.qtyDOM.val(newQty);
    }

    updatePriceField(tdQuantity) {
        let productType = this.table.data('product_type');

        if ('variable' !== productType) {
            let newPrice = '';
            if (tdQuantity.length) {
                newPrice = tdQuantity.data('formatted_price');
            } else {
                jQuery(document).trigger('ywdpd_pre_update_price_html',[this.table,this.mode, tdQuantity]);
                newPrice = this.table.data('price_html');
            }
            let rawPrice = tdQuantity.data('unformatted_price');

            this.updatePriceHtml(newPrice, rawPrice, tdQuantity);
        }
    }

    updatePriceHtml(newPrice, rawPrice, tdQuantity) {
        let extra_class = '';

        if ('' !== newPrice) {
            if (
                this.productDOM.parents('.yith-quick-view-content').length
            ) {
                extra_class = '.yith-quick-view-content ';
            }
            let product_container = jQuery(
                extra_class + ywdpd_qty_args.column_product_info_class
            );
            if (
                !product_container.find('.woocommerce-variation-price')
                    .length
            ) {
                product_container
                    .find(ywdpd_qty_args.product_price_classes)
                    .html(newPrice);
            } else {
                let variations_price = product_container.find(
                    '.woocommerce-variation-price .price'
                );

                variations_price.html(newPrice);
            }

            jQuery(document).trigger('ywdpd_price_html_updated', [
                newPrice,
                rawPrice,
                tdQuantity
            ]);
        }
    }

    showVariationTable(event, variation) {

        if (variation.table_price) {
            let variationTableWrapper = jQuery(variation.table_price);
            const idField  = this.mode === 'classic' ? '#ywdpd-quantity-table' : '#ywdpd-quantity-boxed'
            if (
                variationTableWrapper.find(idField).length
            ) {

                this.elementDOM.html(variationTableWrapper.html());
                this.elementDOM.show();
                if ('yes' !== ywdpd_qty_args.is_default_qty_enabled) {
                    this.updatePriceHtml(variation.price_html, '');
                }
            } else {
                this.elementDOM.html('').hide();
                this.updatePriceHtml(variation.price_html, '');
            }
            this.initTable();
        }
    }

    resetVariationTable() {
        if ('yes' === ywdpd_qty_args.show_variable_table) {
            this.elementDOM.html(this.defaultTable);
            this.initTable();
        } else {
            this.elementDOM.hide();
        }
    }
}